// extracted by mini-css-extract-plugin
export default {"icon":"Dh844C2mY6NahxdSXqcJ"};